/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CourseDocumentsDetailViewModel } from "../types/CourseDocumentsDetailViewModel.ts";
import { courseDocumentsLanguageViewModelSchema } from "./courseDocumentsLanguageViewModelSchema.ts";
import { eEnrollmentStatusSchema } from "./eEnrollmentStatusSchema.ts";
import { eScholarshipStatusSchema } from "./eScholarshipStatusSchema.ts";

export const courseDocumentsDetailViewModelSchema = z.object({
  id: z.optional(
    z.number().int().describe("ID do vínculo entre o curso e o documento."),
  ),
  courseId: z.optional(z.number().int().describe("ID do curso.")),
  courseCode: z.string().describe("Código do curso.").nullish(),
  documentId: z.optional(
    z.number().int().describe("ID do documento-modelo vinculado."),
  ),
  documentName: z
    .string()
    .describe("Nome do documento apresentado para o curso.")
    .nullish(),
  documentActive: z.optional(
    z.boolean().describe("Indica se o documento-modelo está ativo."),
  ),
  isFile: z.optional(
    z
      .boolean()
      .describe(
        "Indica se a declaração é entregue como arquivo PDF em vez de conteúdo HTML.",
      ),
  ),
  useDigitalValidation: z.optional(
    z.boolean().describe("Indica se a declaração usa validação digital."),
  ),
  usePortuguese: z.optional(
    z
      .boolean()
      .describe("Indica se a declaração está habilitada em português."),
  ),
  useEnglish: z.optional(
    z.boolean().describe("Indica se a declaração está habilitada em inglês."),
  ),
  useSpanish: z.optional(
    z.boolean().describe("Indica se a declaração está habilitada em espanhol."),
  ),
  allowedEnrollmentStatus: z
    .array(
      z
        .lazy(() => eEnrollmentStatusSchema)
        .describe(
          "1 = PaymentSelection | 2 = PaymentPending | 3 = ApprovalPending | 4 = Approved | 5 = Activating | 6 = Active | 7 = Transferred | 8 = TransferredInRegistration | 9 = Canceled | 10 = CanceledInRegistration | 11 = Rejected | 12 = FinishedWithPendencies | 13 = Finished | 14 = FinishedWithMonograph | 15 = FinishedWithCertificate | 16 = Blocked | ",
        ),
    )
    .describe(
      "Status de matrícula que permitem ao aluno visualizar a declaração. Lista vazia libera para todos. Enum EEnrollmentStatus: `1` = PaymentSelection, `2` = PaymentPending, `3` = ApprovalPending, `4` = Approved, `5` = Activating, `6` = Active, `7` = Transferred, `8` = TransferredInRegistration, `9` = Canceled, `10` = CanceledInRegistration, `11` = Rejected, `12` = FinishedWithPendencies, `13` = Finished, `14` = FinishedWithMonograph, `15` = FinishedWithCertificate, `16` = Blocked.",
    )
    .nullish(),
  allowedScholarshipStatus: z
    .array(
      z
        .lazy(() => eScholarshipStatusSchema)
        .describe(
          "1 = Interested | 2 = InProcess | 3 = ScholarshipHolder | 4 = Refused | 5 = RefusedInterested | 6 = RefusedPotential | ",
        ),
    )
    .describe(
      "Status de bolsa que permitem ao aluno visualizar a declaração. Lista vazia libera para todos. Enum EScholarshipStatus: `1` = Interested, `2` = InProcess, `3` = ScholarshipHolder, `4` = Refused, `5` = RefusedInterested, `6` = RefusedPotential.",
    )
    .nullish(),
  isSharedWithOtherCourses: z.optional(
    z
      .boolean()
      .describe(
        "Indica se o documento está vinculado a mais de um curso. Quando verdadeiro, alterar o conteúdo por idioma afeta os demais cursos.",
      ),
  ),
  linkedCoursesCount: z.optional(
    z
      .number()
      .int()
      .describe("Quantidade de cursos vinculados ao mesmo documento-modelo."),
  ),
  lastChangeDate: z
    .string()
    .datetime()
    .describe("Data da última alteração do vínculo. Opcional.")
    .nullish(),
  userLastChange: z
    .string()
    .describe("Usuário responsável pela última alteração. Opcional.")
    .nullish(),
  languages: z
    .array(z.lazy(() => courseDocumentsLanguageViewModelSchema))
    .describe(
      "Conteúdos do documento por idioma. Pertencem ao documento-modelo e são compartilhados entre todos os cursos vinculados.",
    )
    .nullish(),
}) as unknown as ToZod<CourseDocumentsDetailViewModel>;
